/**
 * Indica si el prospecto envió el formulario público (/solicitud).
 * Al crear la solicitud desde el admin se guarda en `notes` un texto libre
 * (ej. "Solicitud de … Monto: $…"); el JSON con `savedAt` solo existe tras el PATCH
 * del formulario público (`saveSolicitudPublic`).
 */
export function isPublicSolicitudContestada(notes: string | null | undefined): boolean {
  if (!notes || typeof notes !== 'string' || notes.trim() === '') return false;
  try {
    const p = JSON.parse(notes) as { savedAt?: string };
    return typeof p.savedAt === 'string' && p.savedAt.trim() !== '';
  } catch {
    return false;
  }
}
